import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IJobTitle } from '../job-titles.types';

@Component({
	selector: 'app-job-titles-card',
	templateUrl: './job-titles-card.component.html',
	styleUrls: ['./job-titles-card.component.scss']
})
export class JobTitlesCardComponent implements OnInit {
	constructor(private router: Router) {}

	@Input() public jobTitle: IJobTitle;
	@Input() public isArchived: boolean;

	public ngOnInit(): void {}

	public navigate(id: string): void {
		this.router.navigate(['/pilotpay/job-titles/details', id]);
	}

	public navigateArchived(id: string): void {
		this.router.navigate(['/pilotpay/job-titles/details/archived', id]);
	}
}
